export function NiAnaB(y1, x1, y2, x2) {
  dy = y2 - y1;
  dx = x2 - x1;
  var a;
  //sada proveravas koji je slucaj
  if ((dy == 0) & (dx > 0)) a = 0;
  else if ((dy == 0) & (dx < 0)) a = Math.PI;
  else if ((dy > 0) & (dx == 0)) a = Math.PI / 2;
  else if ((dy < 0) & (dx == 0)) a = (Math.PI / 2) * 3;
  else if ((dy > 0) & (dx > 0))
    //znaci da ne dodajes nista
    a = Math.atan(dy / dx);
  else if ((dy > 0) & (dx < 0)) a = Math.abs(Math.atan(dx / dy)) + Math.PI / 2;
  else if ((dy < 0) & (dx < 0)) a = Math.atan(dy / dx) + Math.PI;
  else if ((dy < 0) & (dx > 0))
    a = Math.abs(Math.atan(dx / dy)) + (Math.PI / 2) * 3;

  return a;
}

export function dAB(y1, x1, y2, x2) {
  return Math.sqrt((y2 - y1) * (y2 - y1) + (x2 - x1) * (x2 - x1));
}

export function koeficijenti_pravca_ab(ugao, duzina) {
  ro = (3600 * 180) / Math.PI;
  koef_a = (Math.sin(ugao) * ro) / (duzina * 1000); //x
  koef_b = (-Math.cos(ugao) * ro) / (duzina * 1000); //y
  return [koef_a, koef_b];
}

export function koeficijenti_duzine_AB(ugao) {
  koef_A = -Math.cos(ugao);
  koef_B = -Math.sin(ugao);
  return [koef_A, koef_B];
}

export function deg2rad(u_decimal) {
  return u_decimal * (Math.PI / 180);
}

export function rad2deg(u_radians) {
  return u_radians * (180 / Math.PI);
}

export function calculateDegreeDecimal(angle) {
  if (angle != 0) {
    const degrees = Math.floor(angle);
    const minutesDecimal = (angle - degrees) * 60;
    const minutes_ = Math.floor(minutesDecimal);
    const seconds_ = Math.round((minutesDecimal - minutes_) * 60);
    return degrees + " " + minutes_ + " " + seconds_;;
  } else {
    return "0 00 00";
  }
}
